import { makeStyles } from '@material-ui/core/styles'

const drawerWidth = 195

export const useStyles = makeStyles(theme => ({
    linkRouter: {
        textDecoration: 'none',
        color: 'white',
        backgroundColor: '#F9D100'
    },
    linkAvatar: {
        width: 50,
    },
    permanent: {
        display: 'flex',
    },
    persistent: {
        display: 'flex',
        marginLeft: -30,
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justify: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    large: {
        marginLeft: '-20px',
        width: theme.spacing(6),
        height: theme.spacing(6),
    },
    largeMargin: {
        width: theme.spacing(6),
        height: theme.spacing(6),
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        color: 'white',
        backgroundColor: "#F9D100"
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    swipeableDrawer: {
        width: drawerWidth
    },
    swipeableDrawerPaper: {
        width: drawerWidth
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        height: '100vh',
        overflowY: 'auto',
        scrollbarWidth: 'none',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        '&::-webkit-scrollbar': {
            display: 'none'
        },
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(6),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(7),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4)
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
    snackbar: {
        bottom: '-1px !Important'
    },
    onlineAlert: {
        opacity: '0.6 !Important'
    },
    link: {
        textDecoration: 'none',
        color: '#000'
    }
}))